import React from 'react';
import { Form, Input, Select, Button } from 'antd';
import CredPhoneInput from '../../components/CredPhoneInput';
import useSettings from 'hooks/useSettings';
import { EnumFields } from 'types/enumerationData';
import SectionHeader from '../../components/SectionHeader';
import OptLabel from '../../components/OptLabel';
import { RELATIONSHIPS, selectOptions } from '../../constants';
import s from '../../s.module.less';

const MIN_REFERENCES = 3;

// Form.List name="references"：数组结构直接对应 references 接口 body（ProviderCredentialingReferenceDto[]）
export default function StepReferences() {
    const [setting] = useSettings();
    const credentialOptions = setting[EnumFields.CREDENTIAL_TYPE] || [];
    return (
        <Form.List name="references" initialValue={[{}, {}, {}]}>
            {(fields, { add, remove }) => (
                <>
                    {fields.map((field, idx) => (
                        <div className={s.wizSection} key={field.key}>
                            <SectionHeader
                                title={`Reference ${idx + 1}`}
                                action={
                                    idx >= MIN_REFERENCES ? (
                                        <button
                                            type="button"
                                            className={s.refRemove}
                                            onClick={() => remove(field.name)}
                                        >
                                            Remove
                                        </button>
                                    ) : null
                                }
                            />
                            <Form.Item
                                name={[field.name, 'fullName']}
                                label="Full name"
                                rules={[{ required: true, message: 'Required' }]}
                            >
                                <Input size="large" placeholder="Reference name" />
                            </Form.Item>
                            <div className={s.wizRow}>
                                <Form.Item name={[field.name, 'title']} label={<OptLabel>Title / specialty</OptLabel>}>
                                    <Input size="large" placeholder="e.g. Psychiatrist, Medical Director" />
                                </Form.Item>
                                <Form.Item name={[field.name, 'credentials']} label={<OptLabel>Credentials</OptLabel>}>
                                    <Select size="large" showSearch placeholder="Select" options={credentialOptions} />
                                </Form.Item>
                                <Form.Item
                                    name={[field.name, 'relationship']}
                                    label={<OptLabel>Relationship</OptLabel>}
                                >
                                    <Select size="large" placeholder="Select" options={selectOptions(RELATIONSHIPS)} />
                                </Form.Item>
                            </div>
                            <Form.Item
                                noStyle
                                shouldUpdate={(p, c) =>
                                    p.references?.[field.name]?.relationship !==
                                    c.references?.[field.name]?.relationship
                                }
                            >
                                {({ getFieldValue }) =>
                                    getFieldValue(['references', field.name, 'relationship']) === 'Other' ? (
                                        <Form.Item
                                            name={[field.name, 'relationshipOther']}
                                            label="Relationship (other)"
                                        >
                                            <Input size="large" placeholder="Specify relationship" />
                                        </Form.Item>
                                    ) : null
                                }
                            </Form.Item>
                            <Form.Item name={[field.name, 'organization']} label={<OptLabel>Organization</OptLabel>}>
                                <Input size="large" placeholder="Organization" />
                            </Form.Item>
                            <div className={s.wizRow}>
                                <Form.Item
                                    name={[field.name, 'phone']}
                                    label="Phone"
                                    rules={[{ required: true, message: 'Required' }]}
                                >
                                    <CredPhoneInput size="large" placeholder="(555) 555-5555" />
                                </Form.Item>
                                <Form.Item
                                    name={[field.name, 'email']}
                                    label="Email"
                                    rules={[{ required: true, type: 'email', message: 'Enter a valid email' }]}
                                >
                                    <Input size="large" placeholder="email@example.com" />
                                </Form.Item>
                            </div>
                        </div>
                    ))}
                    <Button block onClick={() => add()} className={s.refAdd}>
                        + Add another reference
                    </Button>
                </>
            )}
        </Form.List>
    );
}
